var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,attrs:{"id":"app"}},[(_vm.isAuthorized)?_c('tms-header'):_vm._e(),_c('div',{staticClass:"main-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }